/**
 * PrimeVue bileşen locale'leri (DatePicker ay/gün adları, boş liste metinleri).
 * vue-i18n mesajlarından ayrıdır; PrimeVue kendi locale sözlüğünü kullanır.
 */
import { defaultOptions } from 'primevue/config'
import type { AppLocale } from './index'

const tr = {
  ...defaultOptions.locale,
  monthNames: [
    'Ocak',
    'Şubat',
    'Mart',
    'Nisan',
    'Mayıs',
    'Haziran',
    'Temmuz',
    'Ağustos',
    'Eylül',
    'Ekim',
    'Kasım',
    'Aralık',
  ],
  monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
  dayNamesShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
  dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
  firstDayOfWeek: 1,
  today: 'Bugün',
  clear: 'Temizle',
  apply: 'Uygula',
  cancel: 'İptal',
  chooseMonth: 'Ay seçin',
  chooseYear: 'Yıl seçin',
  chooseDate: 'Tarih seçin',
  prevYear: 'Önceki yıl',
  nextYear: 'Sonraki yıl',
  prevMonth: 'Önceki ay',
  nextMonth: 'Sonraki ay',
  weekHeader: 'Hf',
  dateFormat: 'dd.mm.yy',
  emptyMessage: 'Sonuç bulunamadı',
  emptySearchMessage: 'Sonuç bulunamadı',
  emptySelectionMessage: 'Seçili öğe yok',
}

const en = {
  ...defaultOptions.locale,
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
}

const cnr = {
  ...defaultOptions.locale,
  monthNames: [
    'Januar',
    'Februar',
    'Mart',
    'April',
    'Maj',
    'Jun',
    'Jul',
    'Avgust',
    'Septembar',
    'Oktobar',
    'Novembar',
    'Decembar',
  ],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
  dayNames: ['Nedjelja', 'Ponedjeljak', 'Utorak', 'Srijeda', 'Četvrtak', 'Petak', 'Subota'],
  dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
  dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
  firstDayOfWeek: 1,
  today: 'Danas',
  clear: 'Očisti',
  apply: 'Primijeni',
  cancel: 'Otkaži',
  chooseMonth: 'Izaberite mjesec',
  chooseYear: 'Izaberite godinu',
  chooseDate: 'Izaberite datum',
  prevYear: 'Prethodna godina',
  nextYear: 'Sljedeća godina',
  prevMonth: 'Prethodni mjesec',
  nextMonth: 'Sljedeći mjesec',
  weekHeader: 'Sed',
  dateFormat: 'dd.mm.yy',
  emptyMessage: 'Nema rezultata',
  emptySearchMessage: 'Nema rezultata',
  emptySelectionMessage: 'Nema izabranih stavki',
}

export const PRIMEVUE_LOCALES: Record<AppLocale, Record<string, unknown>> = { tr, en, cnr }

export function getPrimeVueLocale(locale: AppLocale) {
  return PRIMEVUE_LOCALES[locale] ?? tr
}
